import React from "react";
import MaterialTableRtl from "../../UI/MaterialTableRtl/MaterialTableRtl";
import { client } from "../../../service/ApolloClient/ApolloClient";
import { QUERY_DEBIT_CREDITS } from "../../../service/ApolloClient/ApolloQueries";
import NumberFormat from "react-number-format";
import { MUTATION_REMOVE_DEBIT_CREDIT } from "../../../service/ApolloClient/ApolloMutation";
import { SuccessToast } from "../../../hoc/ToastNotify/ToastNotify";
import { Tooltip } from "@material-ui/core";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { confirmAlert } from "react-confirm-alert";
import {numberFormatter} from "../../../utility/Number/numberFormatter";

class DebitCreditList extends React.Component {
  tableRef = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      data: [],
      columns: props.isPerson
        ? [
            {
              title: "#",
              field: "id",
              render: (rowData) => {
                return (
                  <a href={`/debit-credit/edit/${rowData.id}`}>{rowData.id}</a>
                );
              },
            },
            {
              title: "تاریخ توافق",
              field: "date",
              render: (rowData) => rowData.date_fa?.split(" ")[0],
              pdfRender: (rowData) => rowData.date_fa?.split(" ")[0],
            },
            {
              title: "ساعت  توافق",
              field: "date",
              render: (rowData) => rowData.date_fa?.split(" ")[1],
              pdfRender: (rowData) => rowData.date_fa?.split(" ")[1],
            },
            {
              title: "بابت",
              field: "about",
              render: (rowData) => rowData.about,
            },
            {
              title: "توضیحات",
              field: "description",
              render: (rowData) =>
                rowData.description ? (
                  <Tooltip
                    title={
                      <span style={{ fontSize: "0.95rem", lineHeight: 1.8 }}>
                        {rowData.description}
                      </span>
                    }
                    interactive
                  >
                    <span
                      style={{
                        display: "block",
                        maxWidth: 200,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        direction: "rtl",
                      }}
                    >
                      {rowData.description}
                    </span>
                  </Tooltip>
                ) : (
                  "-"
                ),
              pdfRender: (rowData) => rowData.description || "-",
              cellStyle: { maxWidth: 200, overflow: "hidden" },
            },
            {
              title: "بدهکاری",
              field: "debt",
              render: (rowData) => (
                <span style={{ color: this.nameType(rowData.type) }}>
                  <NumberFormat
                    value={rowData.type === "debt" ? rowData.amount : ""}
                    thousandSeparator={true}
                    displayType={"text"}
                  />
                </span>
              ),
              pdfRender: (rowData) => {
                return rowData.type === "debt" ? numberFormatter(rowData.amount) : ""
              }
            },
            {
              title: "بستانکاری",
              field: "credit",
              render: (rowData) => (
                <span style={{ color: this.nameType(rowData.type) }}>
                  <NumberFormat
                    value={rowData.type === "credit" ? rowData.amount : ""}
                    thousandSeparator={true}
                    displayType={"text"}
                  />
                </span>
              ),
              pdfRender: (rowData) => {
                return rowData.type === "credit" ? numberFormatter(rowData.amount) : ""
              }
            },
            {
              title: " مانده",
              field: "remained",
              render: (rowData) => (
                <span style={{ color: this.colorRemain(rowData.remained) }}>
                  <NumberFormat
                    value={rowData.remained}
                    thousandSeparator={true}
                    displayType={"text"}
                  />
                </span>
              ),
              pdfRender: (rowData) => (numberFormatter(rowData.remained))
            },
          ]
        : [
            {
              title: "#",
              field: "id",
              render: (rowData) => {
                return (
                  <a href={`/debit-credit/edit/${rowData.id}`}>{rowData.id}</a>
                );
              },
            },
            {
              title: "تاریخ توافق",
              field: "date",
              render: (rowData) => rowData.date_fa?.split(" ")[0],
              pdfRender: (rowData) => rowData.date_fa?.split(" ")[0],
            },
            {
              title: "ساعت  توافق",
              field: "date",
              render: (rowData) => rowData.date_fa?.split(" ")[1],
              pdfRender: (rowData) => rowData.date_fa?.split(" ")[1],
            },
            {
              title: "طرف حساب",
              field: "user_fullname",
              disable: true,
              render: (rowData) =>
                rowData.user_id ? (
                  <a href={`/person/edit/${rowData.user_id}`}>
                    {rowData.user_fullname}
                  </a>
                ) : (
                  "مشخص نشده"
                ),
            },
            {
              title: "بابت",
              field: "about",
              render: (rowData) => rowData.about,
            },
            {
              title: "توضیحات",
              field: "description",
              render: (rowData) =>
                rowData.description ? (
                  <Tooltip
                    title={
                      <span style={{ fontSize: "0.95rem", lineHeight: 1.8 }}>
                        {rowData.description}
                      </span>
                    }
                    interactive
                  >
                    <span
                      style={{
                        display: "block",
                        maxWidth: 200,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        direction: "rtl",
                      }}
                    >
                      {rowData.description}
                    </span>
                  </Tooltip>
                ) : (
                  "-"
                ),
              pdfRender: (rowData) => rowData.description || "-",
              cellStyle: { maxWidth: 200, overflow: "hidden" },
            },
            {
              title: "بدهکاری",
              field: "debt",
              render: (rowData) => (
                <span style={{ color: this.nameType(rowData.type) }}>
                  <NumberFormat
                    value={rowData.type === "debt" ? rowData.amount : ""}
                    thousandSeparator={true}
                    displayType={"text"}
                  />
                </span>
              ),
              pdfRender: (rowData) => {
                return rowData.type === "debt" ? numberFormatter(rowData.amount) : ""
              }
            },
            {
              title: "بستانکاری",
              field: "credit",
              render: (rowData) => (
                <span style={{ color: this.nameType(rowData.type) }}>
                  <NumberFormat
                    value={rowData.type === "credit" ? rowData.amount : ""}
                    thousandSeparator={true}
                    displayType={"text"}
                  />
                </span>
              ),
              pdfRender: (rowData) => {
                return rowData.type === "credit" ? numberFormatter(rowData.amount) : ""
              }
            },
            {
              title: " مانده",
              field: "remained",
              render: (rowData) => (
                <span style={{ color: this.colorRemain(rowData.remained) }}>
                  <NumberFormat
                    value={rowData.remained}
                    thousandSeparator={true}
                    displayType={"text"}
                  />
                </span>
              ),
              pdfRender: (rowData) => (numberFormatter(rowData.remained))
            },
          ],
    };

    this.remoteData = this.remoteData.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  nameType(status) {
    switch (status) {
      case "debt":
        return "#ff0000";
      case "credit":
        return "#006400";
    }
  }

  colorRemain(amount) {
    if (amount < 0) return "#ff0000";
    else return "#006400";
  }

  nameStatus(status) {
    switch (status) {
      case "cleared":
        return "تسویه شده";
      case "not_cleared":
        return "تسویه نشده";
      case "remained":
        return "مانده";
      default:
        return status;
    }
  }

  componentDidMount() {}

  remoteData = (query) => {
    return client
      .query({
        query: QUERY_DEBIT_CREDITS,
        variables: {
          page: query.page + 1,
          limit: query.pageSize,
          search: query.search,
          orderBy: query.orderBy ? query.orderBy.field : null,
          orderDirection: query.orderDirection,
          user: this.props.user,
        },
        fetchPolicy: "network-only",
      })
      .then((res) => {
        let data = structuredClone(res.data);
        return {
          data: data.debtCredits.data,
          page: query.page,
          totalCount: data.debtCredits.total,
        };
      });
  };

  handleRemove = (id) => {
    confirmAlert({
      title: "تاییدیه حذف",
      message: "آیا واقعا می خواهید حذف کنید.",
      buttons: [
        {
          label: "بله",
          onClick: () => {
            client
              .mutate({
                mutation: MUTATION_REMOVE_DEBIT_CREDIT,
                variables: {
                  id: id,
                },
              })
              .then((res) => {
                let d = res.data.removeDebitCredit;
                this.tableRef.current.onQueryChange();
                SuccessToast("با موفقیت حذف گردید");
              })
              .catch((err) => console.log(err));
          },
        },
        {
          label: "بی خیال",
          onClick: () => {},
        },
      ],
    });
  };

  render() {
    const { columns, data } = this.state;
    let title = "بدهی و طلب" + " " + (this.props.name ? this.props.name : "")
    return (
      <MaterialTableRtl
        tableRef={this.tableRef}
        columns={columns}
        data={this.remoteData}
        editLink={"/debit-credit/edit/"}
        handleRemove={this.handleRemove}
        needExport={true}
        pdfOrientation={"landscape"}
        title={title}
        pdfName={this.props.pdfName ? this.props.pdfName : title}
      />
    );
  }
}

export default DebitCreditList;
